import global from './global';

let ModelCollection = {
    
    setModelClass(className, Model){
        if(! global.models.classes.has(className)){
            global.models.classes.set(className, Model);
        }else{
            console.warn('Model class ' + className + ' already registered');
        }
    },

    getModel(name, className=null, settings={}){

        if(name == null){
            if(typeof className == 'string'){
                name = className + 'Model';
            }else{
                try{
                    name = className.constructor.name.toLowerCase() + 'Model';
                }catch(e){   }
            }
        }

        if(name && global.models.instances.has(name)){
            let inst = global.models.instances.get(name);
            // update the used counter
            inst.used++;
            global.models.instances.set(name, inst);
            return inst.model;
        }else if(className){
            let Model = className;
            if(typeof className == 'string'){
                if(global.models.classes.has(className)){
                    Model = global.models.classes.get(className);
                }else{
                    console.warn('Model class ' + className + ' not found.');
                    return null;
                }
            }
            let model = new Model(name, settings);
            if(global.models.instances.has(model.name)){
                console.warn('New model with name ' + name + ' already exists and is now overwritten');
            }

            global.models.instances.set(model.name, {
                model: model,
                used: 1
            });
            return model;
        }
        return null;
    },

    releaseModel(model){
        if(typeof model != 'string'){
            model = model.name;
        }
        let inst = global.models.instances.get(model);
        if(inst){
            if(inst.used == 1){
                inst.model.remove();
                global.models.instances.delete(model);
            }else{
                inst.used--;
                global.models.instances.set(model, inst);
            }
        }
    },

    registerInstance(model, name = false){
         for(let [key, value] of global.models.instances) {
             if(value.model === model){
                value.used++;
                global.models.instances.set(key, value);
                return key;
             }
         }
         if(! name){
             name = model.name;
         }
         if(global.models.instances.has(name)){
             name += Math.round(Math.random()*99999);
         }
         global.models.instances.set(name, {
             used: 1,
             model: model
         });
         return name;

    }

};

export default ModelCollection;